let AppointmentType = {
  UPCOMING: 1,
  PAST: 2
}

export { AppointmentType }
